module.exports = __webpack_public_path__ + "img/enjin-logo.f9ec792e.svg";